import { apiService } from './api';
import { persistUserToLocalStorage } from './authService';
import type { LoginResult } from '@/types/auth';
import type { ApiResponse } from '@/types/apiResponse';

interface SendOtpResponse {
  sent: boolean;
}

type VerifyOtpResponse = ApiResponse<LoginResult>;

class EmailOtpService {
  public async sendOtp(email: string): Promise<ApiResponse<SendOtpResponse>> {
    return apiService.post<ApiResponse<SendOtpResponse>, { email: string }>(
      '/public/api/v1/auth/email-otp/send',
      { email },
    );
  }

  public async verifyOtp(
    email: string,
    code: string,
  ): Promise<VerifyOtpResponse> {
    const response = await apiService.post<
      VerifyOtpResponse,
      { email: string; code: string }
    >('/public/api/v1/auth/email-otp/verify', { email, code });

    if (response.result?.accessToken) {
      localStorage.setItem('accessToken', response.result.accessToken);
      if (response.result.refreshToken) {
        localStorage.setItem('refreshToken', response.result.refreshToken);
      }
      if (response.result.user) {
        persistUserToLocalStorage(response.result.user);
      }
    }

    return response;
  }
}

export const emailOtpService = new EmailOtpService();
